import React, { Component }          from 'react';
import { connect }                   from 'react-redux';
import { Link }                      from 'react-router-dom';
import BatalhaListAprovarQuestao     from './batalha_list_aprovar_questao';
import BatalharProfessorQuestao      from './batalhar_professor_questao';
import { SetError }                  from '../../../actions/notificacaoAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo }       from '../../../actions/scopoAction';


class Batalha_Professor extends Component {

  constructor(props){

       super(props);
       this.state = {

                load          : true,
                duelosAprovar : [],
                use_id        : this.props.session.id
       };
      
  }

  componentWillMount() {
    
    this.props.GetListaMenuTopo([
                                 {action:true,nome:"Home",link:this.props.menu.home},
                                 {action:false,nome:this.props.menu.batalha.nomeModulo}
                                ]);

    this.props.GetListaSubMenuTopo([
                                    {nome:"Questão para aprovação",link : null},
                                    {nome:"Suas questões",link : 1},
                                  ]);

  }

  getRegistroAprovarQuestao(){
   
        this.props.GetByAprovarQuestoesDuelo(this.state.use_id).then((response) =>{
          const retornoQueApro = response.data;
          if(retornoQueApro){
              this.setState({duelosAprovar:retornoQueApro,load:false});        
            }else{
              this.setState({duelosAprovar:[],load:false});        
            }
         }
        ).catch((error) =>{
          this.props.SetError(500);
        });         
  } 

  render () {
   
      const obj = {};
      switch (this.props.checkSelect) {
        case null:
           obj.acao = <BatalhaListAprovarQuestao/>;       
        break;

        case 1:
            obj.acao = <BatalharProfessorQuestao/>;     
        break;
      
        default:
        break;
      }
    return (
            <div className="container-bg">
              <div className="titulo-pages topo_conteudo">
                <Link to={`${this.props.menu.questao}/novo`} className="btn btn-primary pull-right"> Cadastrar</Link>
              </div>   
               {obj.acao}
            </div>
           )
  }
}

function mapStateToProps(state){

    return {
        session           : state.auth.session,
        menu              : state.configReducer.menu,
        checkSelect       : state.scopoReducer.checkSelect,
        listaSubMenuScopo : state.scopoReducer.allListaSubMenu
    }

}
  
export default connect(mapStateToProps, { SetError,GetListaMenuTopo,GetListaSubMenuTopo })(Batalha_Professor);
         


// WEBPACK FOOTER //
// ./src/components/professor/batalha/batalha_professor.js